import React from 'react'
import styled from 'styled-components'
import {
  Image,
  ImageSourcePropType,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'
import { ColumnLayout } from './layout'
import { ButtonShadow } from 'ui/home/bottom-button-styles'
import { BOTTOM_VIEW_BOTTOM_DISTANCE } from 'infra/constant'

export const Container = styled(ColumnLayout)`
  position: absolute;
`

export const IconButton = styled(TouchableOpacity)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
`

export const ShadowWrapper = styled(View)`
  width: 40px;
  height: 40px;
  border-radius: 18px;
`
export const BottomButton = ({
  onPress,
  imageSource,
  style,
}: {
  onPress: () => void
  imageSource: ImageSourcePropType
  style?: StyleProp<ViewStyle>
}) => {
  return (
    <Container
      style={[{ bottom: BOTTOM_VIEW_BOTTOM_DISTANCE }, style]}
      pointerEvents='box-none'
    >
      <IconButton onPress={onPress} activeOpacity={0.8}>
        <ShadowWrapper style={ButtonShadow}>
          <Image source={imageSource} style={{ width: 40, height: 40 }} />
        </ShadowWrapper>
      </IconButton>
    </Container>
  )
}
